export default "__VITE_ASSET__Dm5ABHV6__"